import { Component, OnInit } from '@angular/core';
import { Rep, RoutineModelExercise } from 'src/app/interfaces/exercise';
import { RoutineModel } from 'src/app/interfaces/routine';
import { RoutineService } from 'src/app/services/routine.service';
import { StateService } from 'src/app/services/state.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs, 'es-ES');

@Component({
  selector: 'app-workout-detail',
  templateUrl: './workout-detail.component.html',
  styleUrls: ['./workout-detail.component.scss'],
})
export class WorkoutDetailComponent implements OnInit {
  activeTab: string = 'Entrenamiento';
  workout?: any;
  exercisesByExerciseGroup: any;

  constructor(
    private routineService: RoutineService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.stateService.modalShow$.subscribe((modalShow) => {
      if (modalShow === 'workout') {
        this.getWorkoutDetail();
      }
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  getWorkoutDetail() {
    const workoutId = this.stateService.selectedWorkoutId;
    if (!workoutId) return;

    this.routineService
      .getWorkoutDetail(workoutId)
      .subscribe((workoutDetail) => {
        this.workout = workoutDetail;

        this.getIntensityPrinciplesByExercise();
        this.groupExercisesByExerciseGroup();
      });
  }

  getIntensityPrinciplesByExercise() {
    this.workout?.exercises.forEach((exercise: RoutineModelExercise) => {
      let exerciseIntensityPrinciples: string[] = [];
      let exerciseWeightText: any = [];
      let exerciseRepCount: any = [];

      exercise.reps.forEach((rep: Rep) => {
        if (rep.intensityPrinciples) {
          rep.intensityPrinciples.forEach((ip: string) => {
            if (
              exerciseIntensityPrinciples.filter((IP) => IP == ip).length == 0
            ) {
              exerciseIntensityPrinciples.push(ip);
            }
          });
        }

        exerciseWeightText.push(rep.weight);
        exerciseRepCount.push(rep.quantity);
      });

      exercise.weightText = exerciseWeightText.join(' - ');
      exercise.repCount = exerciseRepCount.join(' - ');
      exercise.intensityPrinciples = exerciseIntensityPrinciples;
    });
  }

  groupExercisesByExerciseGroup() {
    let counter: number = 0;
    let exercisesByExerciseGroup: any = [];
    let exerciseGroup: any = [];

    do {
      counter++;

      exerciseGroup = this.workout?.exercises?.filter(
        (e: any) => e.exerciseGroup == counter
      );

      exerciseGroup = exerciseGroup ? exerciseGroup : [];

      exerciseGroup.length > 0
        ? exercisesByExerciseGroup.push(exerciseGroup)
        : {};
    } while (exerciseGroup.length > 0);

    this.exercisesByExerciseGroup = exercisesByExerciseGroup;
  }
}
